import React from 'react';
import _ from 'lodash';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box } from '@mui/material';
//
import { BaseOptionChart } from '../../../../components/chart';

// ----------------------------------------------------------------------


export const ReservationsChart = props => {
  const { data } = props;

  const CHART_DATA = [
    {
      type: 'column',
      name: 'Liczba zarezerwowanych miejsc',
      data: data.reserved_slots_count || []
    },
    {
      type: 'column',
      name: 'Suma kwot rezerwacji',
      data: data.reserved_amounts || []
    }
  ];

  const chartOptions = _.merge(BaseOptionChart(), {
    stroke: { width: [0, 2, 3] },
    plotOptions: { bar: { columnWidth: '100%' } },
    fill: { type: ['solid'] },
    labels: data.categories || [],
    xaxis: { type: 'datetime' },
    yaxis: [
      {
        title: {
          text: 'Liczba rezerwacji'
        }
      },
      {
        opposite: true,
        title: {
          text: 'Suma kwot rezerwacji'
        }
      }
    ],
    tooltip: {
      shared: false,
      intersect: false,
      y: {
        formatter: y => {
          if (typeof y !== 'undefined') {
            return `${y}`;
          }

          return y;
        }
      },
      x: {
        show: true,
        format: 'dd.MM.yyyy'
      }
    }
  });

  return (
    <Card>
      <CardHeader title="Wykres rezerwacji" />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart series={CHART_DATA} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
};
